import { gql } from '@apollo/client';

export const ROTATIONSPLAN_VORLAGE_BY_ID = gql(`
  query mitarbeiter_rotationsplanVorlageById($rotationsplanVorlageId: String!) {
    mitarbeiter_rotationsplanVorlageById(
      rotationsplanVorlageId: $rotationsplanVorlageId
    ) {
      id
      titel
      land
      standortgruppenId
      beruf {
        id
        name
        abkuerzung
        istAusbildung
        markierung
      }
      abschnitte {
        id
        name
        position
        stationen {
          id
          typ
          position
          dauer
          dauerEinheit
          lernziele
          erinnerungszeiten
          standort {
            id
            name
            storenummer
          }
          arbeitsbereich {
            id
            name
            markierung
          }
          abteilungsleiter {
            id
            vorname
            nachname
          }
        }
      }
    }
  }
`);
